import React from "react";
import {getAdvancementColor} from "./utils";

export const LinearProgressBar = (advancement, stepBehavior=false) => {

    const progressBarStyle = {
        height: '100%',
        width: `${stepBehavior ? advancement*20 : advancement}%`,
        textAlign: 'right',
        borderRadius: '0.4rem',
        background: getAdvancementColor(advancement, stepBehavior)
    }
    return (
        <div className="advancement-div">
            <p> {advancement} % </p>
            <div className="progress-container">
                <div style={progressBarStyle}/>
            </div>
        </div>
    )
}